// extracted by mini-css-extract-plugin
module.exports = {"sign-up-name":"sign-up-name_sign-up-name__2jh-_","form":"sign-up-name_form__3LDA_","input":"sign-up-name_input__1F5Ac"};